// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface NavLeftDoubleIconSignature {
  Element: SVGSVGElement;
}

export const NavLeftDoubleIcon: TOC<NavLeftDoubleIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M4.1 12L12.5 20.4L13.9 19L6.9 12L13.9 4.99998L12.5 3.59998L4.1 12ZM9.1 12L17.5 20.4L18.9 19L11.9 12L18.9 4.99998L17.5 3.59998L9.1 12Z"/>
</svg>
</template>;